import { c as _c } from "react/compiler-runtime";
import React from "react";
import WinnerDropBadge from "../drops/winner/WinnerDropBadge";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface SingleWaveDropPositionProps {
  readonly rank: number | null;
  readonly drop?: ExtendedDrop;
  readonly isFinalWinner?: boolean;
}

// Trophy-only badge component for completed Memes waves
const TrophyOnlyBadge: React.FC<{
  rank: number;
}> = t0 => {
  const $ = _c(7);
  const {
    rank
  } = t0;
  let accentColor;
  let bgColor;
  bb0: switch (rank) {
    case 1:
      {
        accentColor = "#fbbf24";
        bgColor = "rgba(251,191,36,0.1)";
        break bb0;
      }
    case 2:
      {
        accentColor = "#CAD5E3";
        bgColor = "rgba(202, 213, 227,0.1)";
        break bb0;
      }
    case 3:
      {
        accentColor = "#CD7F32";
        bgColor = "rgba(205,127,50,0.1)";
        break bb0;
      }
    default:
      {
        accentColor = "#848490";
        bgColor = "rgba(96,96,108,0.1)";
      }
  }
  const t1 = `1px solid ${accentColor}30`;
  let t2;
  if ($[0] !== accentColor || $[1] !== bgColor || $[2] !== t1) {
    t2 = {
      backgroundColor: bgColor,
      color: accentColor,
      border: t1
    };
    $[0] = accentColor;
    $[1] = bgColor;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-px-2 tw-py-1 tw-text-xs tw-flex tw-items-center"><FontAwesomeIcon icon={faTrophy} className="tw-size-2.5 tw-flex-shrink-0" /></span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="tw-flex tw-items-center tw-rounded-md tw-font-medium tw-whitespace-nowrap -tw-mt-0.5" style={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const SingleWaveDropPosition: React.FC<SingleWaveDropPositionProps> = t0 => {
  const $ = _c(4);
  const {
    rank,
    drop,
    isFinalWinner: t1
  } = t0;
  const isFinalWinner = t1 === undefined ? false : t1;
  if (!rank) {
    return null;
  }
  const isWinner = isFinalWinner || drop?.winning_context;
  if (isWinner) {
    let t2;
    if ($[0] !== rank) {
      t2 = <div className="tw-flex tw-flex-col tw-items-start tw-gap-2"><TrophyOnlyBadge rank={rank} /></div>;
      $[0] = rank;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== rank) {
    t2 = <div className="tw-flex tw-flex-col tw-items-start tw-gap-2"><WinnerDropBadge rank={rank} decisionTime={null} /></div>;
    $[2] = rank;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};